export default __webpack_public_path__ + "static/media/icons8-expand-arrow.bcb1f0e2.svg";